import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/agile";

const GET_REPORT_FORMS = `
	forms (limit: $limit, page: $page, orderBy: $orderBy, search: $search) {
		...ReportFormListPagination
	}
`;

const GET_REPORT_FORM = `
	form (id: $id, list_all_controls:$list_all_controls) {
		...ReportFormConfig
	}
`;

const ADD_REPORT_FORM = `
	create_form (name: $name, category_id: $category_id, code: $code, enable: $enable) {
		...ReportFormDetail
	}
`;

const UPDATE_REPORT_FORM = `
	update_form (id: $id, name: $name, category_id: $category_id, code: $code, enable: $enable) {
		...ReportFormConfig
	}
`;

const DELETE_REPORT_FORM = `
	delete_form (id: $id) {
		...ReportFormDetail
	}
`;

const SUBMIT_REPORT_FORM = `
	submit_form(
		id: $id,
		data: $data
		formable_id: $formable_id,
		formable_type: $formable_type
	){ 
		...ReportFormSubmit
	}
`;

export default {
	init() {},

	getReportForms(payload) {
		const queryOptions = {
			query: gql`query GetReportForms ($limit: Int!, $page: Int!, $search: String, $orderBy: OrderByObject) {
				${GET_REPORT_FORMS}
			}
			${fragments.ReportFormListPagination}
			`,
			variables: {
				search: payload.search,
				page: payload.page || 1,
				limit: payload.limit || -1,
				orderBy: payload.orderBy || null
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => response.data.forms);
    },

    getReportForm(id,list_all_controls=false) {
		const queryOptions = {
			query: gql`query GetReportForm ($id: Int!, $list_all_controls:Boolean) {
				${GET_REPORT_FORM}
			}
			${fragments.ReportFormConfig}
			`,
			variables: {
				id,
				list_all_controls
			}
		};
		return graphqlClient.query(queryOptions).then(response => response.data.form);
    },
    
    addReportForm(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddReportForm (
					$name: String!,
					$code: String!,
					$enable: Boolean!,
					$category_id: Int!
                ) {
                    ${ADD_REPORT_FORM}
                }
                ${fragments.ReportFormDetail}
				`,
				variables: {
					name: payload.name,
					code: payload.code,
					enable: payload.enable,
					category_id: payload.category_id
				}
			})
			.then(response => response.data.create_form);
	},

    updateReportForm(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateReportForm (
                    $id: Int!,
					$name: String!,
					$code: String!,
					$enable: Boolean!,
					$category_id: Int!
                ) {
                    ${UPDATE_REPORT_FORM}
                }
                ${fragments.ReportFormConfig}
				`,
				variables: {
                    id: payload.id,
					name: payload.name,
					code: payload.code,
					enable: payload.enable,
					category_id: payload.category_id
				}
			})
			.then(response => response.data.update_form);
	},

	deleteReportForm(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteReportForm (
                    $id: Int!
                ) {
                    ${DELETE_REPORT_FORM}
                }
                ${fragments.ReportFormDetail}
				`,
				variables: {
                    id
				}
			})
			.then(response => response.data.delete_form);
	},
	
	submitReportForm(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation SubmitReportForm (
					$id: Int!,
					$data: String!,
					$formable_id: Int!,
					$formable_type: String!
                ) {
                    ${SUBMIT_REPORT_FORM}
                }
                ${fragments.ReportFormSubmit}
				`,
				variables: {
					id: payload.id,
					data: payload.data,
					formable_id: payload.formable_id,
					formable_type: payload.formable_type
				}
			})
			.then(response => response.data.submit_form);
	},
};
